import { Complement, ComplementGroup, MenuItem } from '@app/types';
import { createContext, Dispatch, RefObject, SetStateAction, useContext } from 'react';
import { ToastAmountRefAttrs } from './ToastAmount';

export type MenuItemDetailsContextData = {
  menuItem: MenuItem;
  total: number;
  updateTotalFromComplementSelected: (selected: Complement | null, previousSelected: Complement | null) => void;
  sumToTotalFromComplementPrice: (complement: Complement, complementGroupParent: ComplementGroup) => void;
  subtractToTotalFromComplmentPrice: (complement: Complement, complementGroupParent: ComplementGroup) => void;
  amount: number;
  setAmount: Dispatch<SetStateAction<number>>;
  invalidComplementGroup: ComplementGroup | null;
  toastAmountRef: RefObject<ToastAmountRefAttrs>;
};

export const MenuItemDetailsContext = createContext({} as MenuItemDetailsContextData);

export function useMenuItemDetailsContext() {
  return useContext(MenuItemDetailsContext);
}
